import { ADD_ACCOUNT_FIELDS, ADD_CARD_FIELD, ADDING_SOURCE, DELETE_CARD, RENAME_CARD, UPDATE_CARDS, UPDATE_CARDS_LIST } from 'actions/cardsAction';

import update from 'helpers/Immutability';

const findIndexById = (cardsById, id) => {
    return cardsById.findIndex((card) => card.id === id);
};

const cards = (state = {}, action = {}) => {
    let mergeState;
    switch (action.type) {
        case ADD_CARD_FIELD:
            mergeState = update(state, {
                $auto: {
                    cardFields: { $set: action.card },
                },
            });
            break;
        case ADD_ACCOUNT_FIELDS:
            mergeState = update(state, {
                $auto: {
                    accountFields: { $set: action.account },
                },
            });
            break;
        case ADDING_SOURCE:
            mergeState = update(state, {
                $auto: {
                    addingSourceType: { $set: action.source },
                },
            });
            break;
        case UPDATE_CARDS:
            mergeState = update(state, {
                $auto: {
                    isForce: { $set: action.data.isForce },
                    lastAddCardId: { $set: action.data.lastAddCardId },
                    paySystemTo: { $set: action.data.paySystemTo },
                    cards: { $set: action.data.cards },
                },
            });
            break;
        case UPDATE_CARDS_LIST:
            mergeState = update(state, {
                cards: { $merge: action.cards },
            });
            break;
        case RENAME_CARD:
            mergeState = update(state, {
                cards: {
                    [findIndexById(state.cards, action.cardId)]: {
                        alias: { $set: action.name },
                    },
                },
            });
            break;
        case DELETE_CARD:
            mergeState = update(state, {
                cards: { $splice: [[findIndexById(state.cards, action.cardId), 1]] },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default cards;
